import { Suspense } from 'react';
import { ContentJsonLd } from '@/components/content-json-ld';
import { Region } from '@/components/region';
import type { PageWithComponentData } from '@/lib/util/pageLoader.server';
import type { ShopperProducts } from '@/scapi';
import type { EatalyBreadcrumbItem } from '@/components/eataly-breadcrumbs';
import type { RouteDataWithShoppingContext } from '@/lib/shopping-context';
import type { EventCourseCategoryCounts } from '@/lib/event-course-category-counts';
import { EventCourseCategoryCountsProvider } from '@/providers/event-course-category-counts';

export type PillarPageRouteData = RouteDataWithShoppingContext & {
    kind: 'pillarPage';
    category: ShopperProducts.schemas['Category'];
    page: PageWithComponentData;
    categoryId: string;
    pageUrl: string;
    structuredData?: Promise<Record<string, unknown> | null>;
    breadcrumbItems: EatalyBreadcrumbItem[];
    breadcrumbBackgroundClass: string;
    breadcrumbHomeTo?: string;
    breadcrumbMergeHomeWithFirstItem?: boolean;
    primaryCategoryPath: string | null;
    seoSiteName: string;
    eventCourseCategoryCounts?: EventCourseCategoryCounts;
};

export function PillarPageRoute({ data }: { data: PillarPageRouteData }) {
    return (
        <EventCourseCategoryCountsProvider
            pillar={data.shoppingContext?.navigationPillar}
            counts={data.eventCourseCategoryCounts}>
            {data.structuredData && (
                <Suspense fallback={null}>
                    <ContentJsonLd promise={data.structuredData} />
                </Suspense>
            )}
            <Region key={`${data.categoryId}:pillarNavigation`} page={data.page} regionId="pillarNavigation" />
            <Region key={`${data.categoryId}:content`} page={data.page} regionId="content" />
        </EventCourseCategoryCountsProvider>
    );
}
